import { If } from "lib/@components/switch"
import { Box, Stack } from "@mui/material"
import { Bound } from "lib/@components/binding/Bound"
import { RejectionDisplay } from "./rejection-display"

export function RejectionReason({ payload }) {
    return (
        <If truthy={!!payload?.rejection?.reason}>
            <Bound allowEdit={false}>
                <Box
                    sx={{
                        mt: 1,
                        p: 1.5,
                        bgcolor: "error.lighter",
                        borderRadius: 1,
                        wordBreak: "break-word",
                    }}
                >
                    <Stack spacing={1}>
                        <RejectionDisplay payload={payload?.rejection} />
                    </Stack>
                </Box>
            </Bound>
        </If>
    )
}
